import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { AppDispatch, RootState } from 'interfaces';

import Loader from 'components/ui/Loader';
import Layout from 'components/Layout';
import AboutPageSideBar from 'components/AboutPageSideBar';
import PeopleComponent from 'components/People';

import { getPeopleDetails } from './peopleSlice';

const People = () => {
  const intl = useIntl();
  const { peopleId } = useParams();

  const dispatch = useDispatch<AppDispatch>();

  const peopleName = intl.formatMessage({ id: `people.${peopleId}` }) || '???';

  useEffect(() => {
    dispatch(getPeopleDetails({ peopleId, peopleName }));
  }, [dispatch, peopleId, peopleName]);

  const peopleDetails = useSelector((state: RootState) => state.people.peopleDetails);
  const songArt = useSelector((state: RootState) => state.people.songArt);

  return peopleDetails ? (
      <Layout
        sidebar={
          <AboutPageSideBar />
        }
      >
        <PeopleComponent
          peopleDetails={peopleDetails}
          songArt={songArt}
        />
      </Layout>
  ) : <Loader />;
};

export default People;
